import React from 'react'
import { StyleSheet, View, Text, ViewStyle } from 'react-native'

export type CallHeaderInfo = {
  title: string
  value: string
}

type OBCallOutHeader = {
  headerData: Array<CallHeaderInfo>
  headerStyles?: ViewStyle
  OBCallOutHeaderMessage: () => JSX.Element
}
export const OBCallOutHeader = (props: OBCallOutHeader) => {
  // const { t } = useTranslation()
  const { headerData, OBCallOutHeaderMessage, headerStyles } = props
  return (
    <View>
      <View style={[callDetailStyles.headerContainer, headerStyles]}>
        {headerData && headerData.map((dataItem, index) => {
          return (
            <View style={callDetailStyles.headerContent} key={'headerData_' + index}>
              <Text style={callDetailStyles.headerTitle}>{dataItem.title}</Text>
              <Text style={callDetailStyles.headerText}>{dataItem.value}</Text>
            </View>
          )
        })}
        {/* <View style={callDetailStyles.headerContent}>
          <Text style={callDetailStyles.headerTitle}>{t('Calling program')}</Text>
          <Text style={callDetailStyles.headerText}>SQCB</Text>
        </View>
        */}
      </View>
      {OBCallOutHeaderMessage()}
    </View>
  )
}

const callDetailStyles = StyleSheet.create({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: 8,
    backgroundColor: '#fff',
    marginHorizontal: 24,
    marginTop: 16,
    borderRadius: 8,
    justifyContent: 'space-around'
    // paddingLeft: 69
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'column'
  },
  headerTitle: {
    color: '#000',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 22
  },
  headerText: {
    color: '#ED1B2E',
    // fontFamily: 'Noto Sans',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 22
  },
})